import React from "react";

const stepData = [
  {
    id: 1,
    head: "Step 1",
    text: "Share Your Requirements",
  },
  {
    id: 2,
    head: "Step 2",
    text: "Get Curated Profiles",
  },
  {
    id: 3,
    head: "Step 3",
    text: "Schedule Interview & Sign NDA",
  },
  {
    id: 4,
    head: "Step 4",
    text: "Get Resources on Board Remotely",
  },
];

const Step = () => {
  return (
    <>
      <section className="stepSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-down">
                <h3>
                  <span>Steps To Get Best Remote Developer</span>
                </h3>
                <p>
                  Get top dedicated resources on your team - in just 4 easy steps.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <ul className="infoGraphic">
                {stepData.map((each, i) => (
                  <li key={i}>
                    <div className="numberWrap" data-aos="zoom-in">
                      <div className="number fontColor1">{each.id}</div>
                      <div className="coverWrap">
                        <div className="numberCover"></div>
                      </div>
                    </div>
                    <div className="content" data-aos="slide-right">
                      <h2>{each.head}</h2>
                      <p>{each.text}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step;
